<div class="definitions-editor-conatiner">
  <opath-core-nav-header
    #header
    [title]="translation?.title"
    [height]="100"
    [buttons]="hedaerButtons"
    (onFilterOptionChanged)="filterOptionChanged($event)"
    (onSearchTermChanged)="searchTermChanged($event)"
    >
  </opath-core-nav-header>
  <div class="parameter-definitions">
    <abc-scroll-view>
      <abc-list
        [dataSource]="parameterDefinitions"
        [focusStateEnabled]="false"
        [activeStateEnabled]="false"
        [searchValue]="searchTerm"
        [searchExpr]="'Caption'"
        [searchMode]="currentFilterOption?.searchMode ?? 'contains'"
        >
        <div style="padding: 0px" *dxTemplate="let parameter of 'item'">
          @if (currentParameterDefinitions[0] !== parameter) {
            <div class="definitions">
              <abc-button
                [width]="'100%'"
                [height]="'20px'"
                [icon]="parameter.IsUserCreated ? ' dx-icon-unlock' : ' dx-icon-lock'"
                [text]="parameter.Caption?.length ? parameter.Caption : parameter.Name"
              [toolTipContent]="
                (parameter.Caption?.length ? parameter.Caption : parameter.Name) + ' = $' + parameter.Name
              "
                [class.user-created-parameter]="parameter.IsUserCreated"
                (onClick)="selectParameter(parameter.Name)"
              ></abc-button>
              @if (parameter.IsUserCreated) {
                <div class="parameter-controls">
                  <abc-button
                    icon="edit"
                    (onClick)="editParameter(parameter.Name)"
                    [disabled]="currentParameterDefinitions.length"
                    [toolTipContent]="translation?.edit"
                  ></abc-button>
                  <abc-button
                    icon="trash"
                    [toolTipContent]="translation?.delete"
                    (onClick)="deleteParameter(parameter.Name)"
                  ></abc-button>
                </div>
              }
            </div>
          } @else {
            <abc-accordion
              [dataSource]="currentParameterDefinitions"
              [collapsible]="true"
              [multiple]="false"
              [animationDuration]="300"
              >
              <div *dxTemplate="let parameter of 'title'">
                <p>{{ translation?.edit + ': ' + (parameter.Caption?.length ? parameter.Caption : parameter.Name) }}</p>
              </div>
              <div *dxTemplate="let parameter of 'item'">
                @if (!loading) {
                  <parameters-definitions-editor-container
                    [initialized]="true"
                    [objectTypesInfo]="objectTypesInfo"
                    [pickListByNameDataSource]="pickListByNameDataSource"
                    [pickListByColumnDataSource]="pickListByColumnDataSource"
                    [parameterDefinition]="parameter"
                    [parameterDefinitions]="parameterDefinitions"
                    [cancelChanges]="cancelChanges"
                    [saveChanges]="saveChanges"
                  ></parameters-definitions-editor-container>
                }
              </div>
            </abc-accordion>
          }
        </div>
      </abc-list>
      @if (currentParameterDefinitions.length && !parameterDefinitions.includes(currentParameterDefinitions[0])) {
        <abc-accordion
          [(dataSource)]="currentParameterDefinitions"
          [collapsible]="true"
          [multiple]="false"
          [animationDuration]="300"
          >
        <div *dxTemplate="let parameter of 'title'">
          <p>{{ translation?.newParameter }}</p>
        </div>
        <div *dxTemplate="let parameter of 'item'">
          @if (!loading) {
            <parameters-definitions-editor-container
              [objectTypesInfo]="objectTypesInfo"
              [pickListByNameDataSource]="pickListByNameDataSource"
              [pickListByColumnDataSource]="pickListByColumnDataSource"
              [parameterDefinition]="parameter"
              [parameterDefinitions]="parameterDefinitions"
              [cancelChanges]="cancelChanges"
              [saveChanges]="saveChanges"
            ></parameters-definitions-editor-container>
          }
        </div>
      </abc-accordion>
    }
  </abc-scroll-view>
</div>
</div>
